module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA7.619fcdf1.jpg";